export default "__VITE_ASSET__C3Cxg0zY__"